module.exports = __webpack_public_path__ + "static/media/Ticket Hoss - Dark BG.8b91769f.svg";